<template>
  <div
    class="d-flex flex-column align-center justify-center"
    style="height: 75vh"
  >
    <v-icon size="32" color="blue-grey lighten-1" class="mb-3">
      mdi-magnify
    </v-icon>
    <p class="ma-0 pa-0 subtitle-2 blue-grey--text text--darken-1 mb-1">
      {{ $t('boards.search_empty_state_title') }}
    </p>
    <p
      style="max-width: 400px"
      class="ma-0 pa-0 caption blue-grey--text mb-5 text-center"
    >
      {{ $t('boards.search_empty_state_subtitle') }}
    </p>
    <v-btn
      color="blue"
      rounded
      elevation="0"
      class="white--text"
      data-tourid="boards-emptyState-createButton"
      :to="{ name: 'createBoard' }"
      >{{ $t('boards.create_new_board') }}</v-btn
    >
  </div>
</template>

<script>
export default {
  name: 'EmptyState',
}
</script>
